import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { ThemeProps } from '@/types/theme';

export type ThemeComponent = ComponentType<ThemeProps>;

export const THEME_COMPONENTS: Record<string, LazyExoticComponent<ThemeComponent>> = {
  // Legacy (original 10)
  'page-flip': lazy(() => import('@themes/page-flip')),
  'scrolling-long-form': lazy(() => import('@themes/scrolling-long-form')),
  'grid': lazy(() => import('@themes/grid')),
  'photo-essay': lazy(() => import('@themes/photo-essay')),
  'news-column': lazy(() => import('@themes/news-column')),
  'magazine-grid': lazy(() => import('@themes/magazine-grid')),
  'minimal-one-pager': lazy(() => import('@themes/minimal-one-pager')),
  'timeline': lazy(() => import('@themes/timeline')),
  'data-viz': lazy(() => import('@themes/data-viz')),
  'podcast-transcript': lazy(() => import('@themes/podcast-transcript')),

  // Classic Print
  'economist': lazy(() => import('@themes/economist')),
  'vogue': lazy(() => import('@themes/vogue')),
  'natgeo': lazy(() => import('@themes/natgeo')),
  'financial-times': lazy(() => import('@themes/financial-times')),
  'the-atlantic': lazy(() => import('@themes/the-atlantic')),
  'new-yorker': lazy(() => import('@themes/new-yorker')),
  'rolling-stone': lazy(() => import('@themes/rolling-stone')),
  'scientific-american': lazy(() => import('@themes/scientific-american')),
  'time-magazine': lazy(() => import('@themes/time-magazine')),
  'harpers-bazaar': lazy(() => import('@themes/harpers-bazaar')),

  // Digital-Native
  'substack-letter': lazy(() => import('@themes/substack-letter')),
  'ghost-minimal': lazy(() => import('@themes/ghost-minimal')),
  'medium-reader': lazy(() => import('@themes/medium-reader')),
  'mirror-essay': lazy(() => import('@themes/mirror-essay')),
  'beehiiv-newsletter': lazy(() => import('@themes/beehiiv-newsletter')),
  'notion-doc': lazy(() => import('@themes/notion-doc')),
  'readwise-highlights': lazy(() => import('@themes/readwise-highlights')),
  'indie-log': lazy(() => import('@themes/indie-log')),
  'paragraph-web3': lazy(() => import('@themes/paragraph-web3')),
  'ghost-magazine': lazy(() => import('@themes/ghost-magazine')),

  // Immersive / Cinematic
  'snow-fall': lazy(() => import('@themes/snow-fall')),
  'cinematic-dark': lazy(() => import('@themes/cinematic-dark')),
  'full-bleed-parallax': lazy(() => import('@themes/full-bleed-parallax')),
  'photo-essay-v2': lazy(() => import('@themes/photo-essay-v2')),
  'gallery-wall': lazy(() => import('@themes/gallery-wall')),
  'comic-strip': lazy(() => import('@themes/comic-strip')),
  'zine-underground': lazy(() => import('@themes/zine-underground')),
  'brutalist': lazy(() => import('@themes/brutalist')),
  'swiss-international': lazy(() => import('@themes/swiss-international')),
  'bauhaus-minimal': lazy(() => import('@themes/bauhaus-minimal')),

  // Cultural / Regional
  'afrofuturist': lazy(() => import('@themes/afrofuturist')),
  'nikkei-grid': lazy(() => import('@themes/nikkei-grid')),
  'latin-editorial': lazy(() => import('@themes/latin-editorial')),
  'nordic-minimal': lazy(() => import('@themes/nordic-minimal')),
  'middle-eastern-rtl': lazy(() => import('@themes/middle-eastern-rtl')),
  'mediterranean-warm': lazy(() => import('@themes/mediterranean-warm')),
  'south-asian-vibrant': lazy(() => import('@themes/south-asian-vibrant')),
  'pan-african-earthy': lazy(() => import('@themes/pan-african-earthy')),
  'colonial-archive': lazy(() => import('@themes/colonial-archive')),
  'afropunk-digital': lazy(() => import('@themes/afropunk-digital')),

  // Functional / Specialist
  'qa-interview': lazy(() => import('@themes/qa-interview')),
  'podcast-v2': lazy(() => import('@themes/podcast-v2')),
  'data-dashboard': lazy(() => import('@themes/data-dashboard')),
  'legal-document': lazy(() => import('@themes/legal-document')),
  'recipe-lifestyle': lazy(() => import('@themes/recipe-lifestyle')),
  'travel-guide': lazy(() => import('@themes/travel-guide')),
  'sports-recap': lazy(() => import('@themes/sports-recap')),
  'event-liveblog': lazy(() => import('@themes/event-liveblog')),
  'annual-report': lazy(() => import('@themes/annual-report')),
  'academic-paper': lazy(() => import('@themes/academic-paper')),
};
